const RECEIVE_PROPERTY_ASSOCIATION =
  'rp/propertyAssociation/RECEIVE_PROPERTY_ASSOCIATION'

// reducer
export default (state = {}, { type, payload }) => {
  switch (type) {
    case RECEIVE_PROPERTY_ASSOCIATION:
      return { ...state, ...payload }
    default:
      return state
  }
}

// action creators
export const receivePropertyAssociation = payload => ({
  type: RECEIVE_PROPERTY_ASSOCIATION,
  payload,
})
